module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-152x152-098fe638552bb2902405fabc3d204aa6.png";